export const Completed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clip-path="url(#clip0_647_12214)">
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="#197335"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3523 16.3523C10.5719 16.1326 10.9281 16.1326 11.1477 16.3523L13.75 18.9545L20.8523 11.8523C21.0719 11.6326 21.4281 11.6326 21.6477 11.8523C21.8674 12.0719 21.8674 12.4281 21.6477 12.6477L14.1477 20.1477C13.9281 20.3674 13.5719 20.3674 13.3523 20.1477L10.3523 17.1477C10.1326 16.9281 10.1326 16.5719 10.3523 16.3523Z"
          fill="#2E2E38"
        />
      </g>
      <defs>
        <clipPath id="clip0_647_12214">
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
